import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const searchByTerm = async (search, establecimientoId ) => {

  if(!establecimientoId){
    console.error("establecimientoId es required");
    return null;
  }

  const query = `
    query AllMedicamentos(
      $search: String,
      $establecimiento: String,
      $estado : String
    ) {
      allMedicamentos(
        search: $search,
        establecimiento: $establecimiento,
        estado : $estado
      ) {
        medicamentos {
          id
          token
          nombre
          presentacion
          codigo
          numMax
          establecimiento
          precioNeto
          precioTecho
        }
      }
    }
  `;

  const variables = {
    search,
    establecimiento : establecimientoId,
    estado : '1'
  };

  try {

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allMedicamentos;

    if( response2.medicamentos.length === 0 ) return null;

    const data = response2.medicamentos;

    const dataMap = data.map(item => ({
      ...item,
      text: item.nombre,
      value: item.id
    }));
    
    return dataMap

  } catch (error) {
    console.error(error);
    return error;
  }
}

export const medicamentosService = {
  searchByTerm
}
